import React from "react";
import MSkeleton from "@/components/ui/atoms/MSkeleton";
import styles from "../MemberDetail.module.css";

/**
 * Placeholder shown while the member record and its card-section data
 * (lab trends, pillbox, reminders, records, Maatra summary) are still
 * loading — avoids each card popping in separately as its own fetch settles.
 */
const MemberDetailSkeleton: React.FC = () => {
  return (
    <div className={styles.container}>
      {/* Member Info row */}
      <div className={styles.memberInfoHorizontal}>
        <div className={styles.leftSection}>
          <MSkeleton className="h-20 w-20 rounded-full" />
        </div>
        <div className="flex flex-1 flex-col gap-3 pt-1">
          <MSkeleton className="h-6 w-40 rounded-full" />
          <MSkeleton className="h-4 w-24 rounded-full" />
        </div>
      </div>

      {/* Quick actions row */}
      <div className="mb-6 flex w-full items-center gap-6">
        {[0, 1, 2].map((i) => (
          <div key={i} className="flex flex-1 flex-col items-center gap-2">
            <MSkeleton className="h-14 w-14 rounded-2xl" />
            <MSkeleton className="h-3 w-16 rounded-full" />
          </div>
        ))}
      </div>

      {/* Cards */}
      <div className="flex w-full flex-col gap-4">
        {[0, 1, 2, 3, 4, 5].map((i) => (
          <MSkeleton key={i} className="h-24 w-full rounded-2xl" />
        ))}
      </div>

      {/* Profile access */}
      <div className="mt-6 w-full">
        <MSkeleton className="mb-3 h-4 w-32 rounded-full" />
        <MSkeleton className="h-16 w-full rounded-2xl" />
      </div>
    </div>
  );
};

export default MemberDetailSkeleton;
